import React, { useState, useEffect } from "react";
import { Tab, Box, Alert, Snackbar } from "@mui/material";
import Preset from "./Preset";
import MachineSchedule from "./MachineSchedule";
import Management from "./Management";
import { useLocation, useParams } from "react-router-dom";
import * as S from "./styles";
import CustomTabPanel from "./CustomTabPanel";
import FactoryHours from "./FactoryHours";

// 기준정보 - 가동시간 관리
function FactoryManagement() {
  const { group_code, project_code } = useParams();
  const location = useLocation();
  const [currentTab, setCurrentTab] = useState(
    location.state?.initialTab !== undefined ? location.state.initialTab : 0
  );
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success", // 'success', 'error', 'warning', 'info'
  });
  const openSnackbar = (message, severity = "success") => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };
  const closeSnackbar = () => {
    setSnackbar({
      ...snackbar,
      open: false,
    });
  };
  const handleTabChange = (_, newValue) => {
    setCurrentTab(newValue);
  };
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  return (
    <>
      <S.PageContainerIndex>
        {/* <div className="title_text_for_frame">가동시간 관리</div> */}
        <S.ContentWrapperIndex>
          <Box sx={{ height: "95%" }}>
            <S.StyledTabsIndex
              value={currentTab}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="프리셋 설정" />
              <Tab label="관리" />
              <Tab label="장비 일정 관리" />
              <Tab label="요일별 가동시간 관리" />
            </S.StyledTabsIndex>
            <CustomTabPanel value={currentTab} index={0}>
              <Preset
                openSnackbar={openSnackbar}
                group_code={group_code}
                project_code={project_code}
              />
            </CustomTabPanel>
            <CustomTabPanel value={currentTab} index={1}>
              <Management
                setCurrentTab={setCurrentTab}
                openSnackbar={openSnackbar}
                group_code={group_code}
                project_code={project_code}
              />
            </CustomTabPanel>
            <CustomTabPanel value={currentTab} index={2}>
              <MachineSchedule
                openSnackbar={openSnackbar}
                group_code={group_code}
                project_code={project_code}
              />
            </CustomTabPanel>
            <CustomTabPanel value={currentTab} index={3}>
              <FactoryHours
                openSnackbar={openSnackbar}
                isModal={false}
                group_code={group_code}
                project_code={project_code}
              />
            </CustomTabPanel>
          </Box>
        </S.ContentWrapperIndex>
      </S.PageContainerIndex>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={2000}
        onClose={closeSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={closeSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}

export default FactoryManagement;
